 function updateCartWithRetry(updates, retries = 3, delay = 3000) {
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: JSON.stringify({ updates }),
      contentType: "application/json",
      success: function (data) {
        console.log("Cart updated successfully:", data);
        window.location.href= '/cart';
      },
      error: function (xhr) {
      window.location.href= '/cart';
      },
    });
  }

$(document).on("click",".link.line_item_to_remove",function() {
    var currentId = $(this).attr('data-id');
    var currentQty = 0;

  var shippingId = 53910802071876;
  var giftId = 54158128120132;

    var data = {
            id: currentId,
            quantity: currentQty
        };

  updateCartWithRetry({ [currentId]: 0, [shippingId]: 0, [giftId]: 0 });
    // jQuery.ajax({
    //         type: "POST",
    //         url: "/cart/change.js",
    //         data: data,
    //         dataType: "json",
    //         success: function (response) {
    //             window.location.href = '/cart';
    //         },
    //         error: function (jqxhr, status, exception) {
    //             alert('Exception:', exception);
    //         }
    // });
    
  });